import "moment/locale/es";
import "moment/locale/de";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend"; // Lazy loading backend

i18n.use(Backend) // Lazy load translations from JSON files
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: "en",
        debug: process.env.NODE_ENV === "development",
        detection: {
            order: ["navigator", "cookie", "localStorage"],
            caches: ["cookie", "localStorage"], // Stores user language preference
        },
        backend: {
            loadPath: "/locales/{{lng}}.json", // Load translations from JSON
            crossDomain: true,
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        returnNull: false,
        returnObjects: false,
        lng: navigator.language.split("-")[0], // force i18next to ignore country codes
        react: {
            useSuspense: false, // prevents issues with React Suspense
        },
    });

export default i18n;
